mutation GeneratePairingCode($companyId: ID!) {
  generatePairingCode(input: { companyId: $companyId }) {
    code
    expiresAt
    errors
  }
}